import React from 'react';
import { ShieldCheckIcon, ClockIcon, LeafIcon } from 'lucide-react';
export function WhyChooseUs() {
  return <section id="why-us" className="bg-[#F5F7FA] py-20 px-4 sm:px-6 lg:px-8" data-id="element-213">
      <div className="max-w-7xl mx-auto" data-id="element-214">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-16" data-id="element-215">
          Why Businesses Choose Us
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-216">
          {/* Card 1 */}
          <div className="bg-white rounded-xl shadow-sm p-8 text-center hover:shadow-md transition-shadow" data-id="element-217">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#0E7C86]/10 rounded-full mb-6" data-id="element-218">
              <ShieldCheckIcon className="w-8 h-8 text-[#0E7C86]" data-id="element-219" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-220">
              Insured & Background-Checked
            </h3>
            <p className="text-gray-600" data-id="element-221">
              Every team member is fully vetted, insured, and trained to our
              rigorous standards.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-xl shadow-sm p-8 text-center hover:shadow-md transition-shadow" data-id="element-222">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#0E7C86]/10 rounded-full mb-6" data-id="element-223">
              <ClockIcon className="w-8 h-8 text-[#0E7C86]" data-id="element-224" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-225">
              Flexible Scheduling
            </h3>
            <p className="text-gray-600" data-id="element-226">
              Day, night, or weekend — we clean on your schedule so your
              business never skips a beat.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-xl shadow-sm p-8 text-center hover:shadow-md transition-shadow" data-id="element-227">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#0E7C86]/10 rounded-full mb-6" data-id="element-228">
              <LeafIcon className="w-8 h-8 text-[#0E7C86]" data-id="element-229" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-230">
              Eco-Friendly Products
            </h3>
            <p className="text-gray-600" data-id="element-231">
              Green-certified cleaning solutions that are tough on grime and
              gentle on the environment.
            </p>
          </div>
        </div>
      </div>
    </section>;
}